"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const AddMultiple = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.8 7.433h-2.56V10.1H8.96V7.433H6.4V6.1h2.56V3.433h1.28V6.1h2.56v1.333zM9.6.1c-.84 0-1.673.172-2.45.507a6.39 6.39 0 00-2.075 1.446A6.81 6.81 0 003.2 6.767a6.81 6.81 0 001.875 4.714c.594.619 1.3 1.11 2.076 1.445a6.179 6.179 0 002.45.507 6.273 6.273 0 004.525-1.952A6.81 6.81 0 0016 6.767c0-.876-.165-1.743-.487-2.552a6.691 6.691 0 00-1.387-2.162A6.39 6.39 0 0012.049.607 6.179 6.179 0 009.6.1zM2.344 3.283C.864 4.55 0 6.442 0 8.433a6.81 6.81 0 001.875 4.714A6.273 6.273 0 006.4 15.1c.512 0 1.016-.067 1.504-.192-1.408-.325-2.704-1.058-3.768-2.066-1.56-.867-2.536-2.567-2.536-4.409 0-.25.024-.491.056-.741a8.968 8.968 0 01-.056-.925c0-1.2.256-2.392.744-3.484z",
  className: "fill"
}));
var _default = exports.default = AddMultiple;